export default "__VITE_ASSET__RZq_47C2__"